<template>
	<div>
		<div class="col-md-4 col-md-offset-4">
			<div class="authenticate">
				<h2>Please Wait</h2>

				<div class="wrap-fluid">
					<div class="row">
						<div class="col-lg-12">
							<div class="account-box">
								<i class="fa fa-fw fa-spin fa-cog"></i> Authenticating you with the AWRI Wine Simulator...
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	ol {
		font-size: 16px;
	}

	ol li {
		margin-bottom: 8px;
	}

	li.disabled {
		opacity: 0.3;
	}

	li.active {
		font-weight: 700;
	}
</style>

<script>
	import { Sites as SiteActions, App as AppActions, User as UserActions } from 'vx/actions'
	import Alert from 'utils/alert'
	import { config } from '../../config'

	export default {
		data() {
			return {
				authenticating: false
			};
		},

		vuex: {
			actions: {
				setTitle: AppActions.title,
				selectSite: SiteActions.select,
				authenticateWithWinecloud: UserActions.authenticateWithWinecloud
			}
		},

		ready() {
			this.setTitle('');
			this.selectSite({});

			if (this.$route.query.user && this.$route.query.pass) {
				let username = this.$route.query.user,
					password = this.$route.query.pass;

				// Replace the route so we clear away the username and password query strings,
				// we don't want these hanging around within the address bar for too long.
				this.$router.replace('authorize');

				this.authenticating = true;

				// Now we can authenticate the username and password we got from WineCloud.
				// We have to proxy this request via our own API. This will fetch us an
				// access token which we will then be able to use
				this.authenticateWithWinecloud(username, password).then(response => {
					this.authenticating = false;

					this.gotoSiteSelection();
				}, response => {
					this.authenticating = false;

					this.backToWineCloud(`${response.body.message} We will now redirect you back to WineCloud.`);
				});
			} else {
				this.backToWineCloud();
			}
		},

		methods: {
			gotoSiteSelection() {
				this.$router.go({ name: 'site-selection.index' });
			},

			backToWineCloud(text = 'Sorry, but you are unauthorized to access this application. We will now redirect you back to WineCloud.') {
				Alert.error({ title: 'Unauthorized!', text}).then(() => {
					window.location = config.WC_PATH;
				});
			}
		}
	};
</script>



// WEBPACK FOOTER //
// authorize.vue?00adb5ba